import { Flex, Input, Text } from '@chakra-ui/react'
import { FC } from 'react'

import { ILayoutToolsHeaderProps } from '@base/@types/components/Layout/Tools'

const LayoutToolsHeader: FC<ILayoutToolsHeaderProps> = ({
  title,
  onChange,
  isEditable
}) => {
  const handleInputChange = (e: any) => {
    const { value } = e.target

    onChange(value)
  }

  const quantityLetters = title.length * 9

  return (
    <Flex width="100%" mb={isEditable ? 1 : 0}>
      {isEditable ? (
        <Input
          variant="outline"
          borderColor="gray.100"
          fontSize="16px"
          size="xs"
          minW={`${quantityLetters}px`}
          value={title}
          onChange={handleInputChange}
          _hover={{
            borderColor: 'yellow.400'
          }}
        />
      ) : (
        <Text ml={1} fontSize="18px" fontWeight="600">
          {title}
        </Text>
      )}
    </Flex>
  )
}
export default LayoutToolsHeader
